import { Directive, HostBinding, Input } from '@angular/core';

export enum StickyDirection {
  NONE,
  LEFT,
  RIGHT,
}

@Directive({ selector: '[superTableSticky]' })
export class SuperTableStickyDirective {
  @Input() superTableSticky: StickyDirection = StickyDirection.LEFT;

  @HostBinding('class.sticky-left') get stickyLeft() {
    return this.superTableSticky === StickyDirection.LEFT;
  }
  @HostBinding('class.sticky-right') get stickyRight() {
    return this.superTableSticky === StickyDirection.RIGHT;
  }
}
